const styles = () => ({
  ceo: {
    marginTop: 60,
    width: '100%',
    textAlign: 'center',
  },
});

export default styles;
